import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Modal } from 'react-bootstrap';
import { notificar } from '../../components/SistemaToast/notificar';
import DateInput from '../../components/DateInput/DateInput';
import { urlApiProd } from '../utiles';
import AgregarProducto from '../productos/AgregarProducto';

const obtenerFechaActual = () => {
  const today = new Date();
  const year = today.getFullYear();
  let month = today.getMonth() + 1;
  let day = today.getDate();

  month = month < 10 ? '0' + month : month;
  day = day < 10 ? '0' + day : day;

  return `${year}-${month}-${day}`;
};

const AgregarOrdenCompra = ({ ordenesCompra, proformas, proveedores, incoterms, puertos, productos, documentos, usuarios, categorias, especies, medidas, calidades, clientes, almacenes, cerrar }) => {
  const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);
  const [emision, setEmision] = useState(obtenerFechaActual());
  const [ordenCompraBase, setOrdenCompraBase] = useState('');
  const [proforma, setProforma] = useState('');
  const [hc, setHc] = useState('');
  const [proveedor, setProveedor] = useState(0);
  const [entrega, setEntrega] = useState('');
  const [almacen, setAlmacen] = useState(0);
  const [condicion_pago, setCondicionPago] = useState('');
  const [requisitos_calidad, setRequisitosCalidad] = useState('');
  const [requisitos_etiquetado, setRequisitosEtiquetado] = useState('');
  const [incoterm, setIncoTerm] = useState(0);
  const [puerto, setPuerto] = useState(0);
  const [descripcion_producto, setDescripcionProducto] = useState('');
  const [Productos, setProductos] = useState([]);
  const [valor_ordencompra, setValorOrdenCompra] = useState(0);
  const [documentosRequeridos, SetDocumentosRequeridos] = useState([]);
  const estado = 2;
  const id = localStorage.getItem('ID');
  const [remitente, setRemitente] = useState(parseInt(id));
  const [aprobador, setAprobador] = useState(0);
  const [informacion_adicional, setInformacionAdicional] = useState('');
  const [nuevoDocumento, setNuevoDocumento] = useState(0);
  const [observaciones, setObservaciones] = useState('');
  const [productosRequeridos, setProductosRequeridos] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [calidadSeleccionada, setCalidadSeleccionada] = useState(null);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]); // Para manejar la lista de productos agregados
  const [productosDisponibles, setProductosDisponibles] = useState([]);
  const [indicadorIT, setIndicadorIT] = useState(null);
  const [origen, setOrigen] = useState('Brazil');
  const [proveedoresFiltrados, setProveedoresFiltrados] = useState([]);
  const [allowance, setAllowance] = useState(0);
  const [moneda, setMoneda] = useState(0);
  const [fechaEmbarqueProforma, setFechaEmbarqueProforma] = useState('');
  const [correlativo, setCorrelativo] = useState(0);
  const [empresaEmisor, setEmpresaEmisor] = useState(0);
  const [m3, setM3] = useState('');
  const [usdM3, setUsdM3] = useState('');
  const [showAgregarProducto, setShowAgregarProducto] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [productoEnEdicion, setProductoEnEdicion] = useState(null);
  const [id_oc, setIdOc] = useState('');
  const [descripcionFiltro, setDescripcionFiltro] = useState('');
  const [productNames, setProductNames] = useState([]);
  const [productSearchTerm, setProductSearchTerm] = useState('');
  const [showProductSearchDropdown, setShowProductSearchDropdown] = useState(false);
  const productSearchDropdownRef = useRef(null);

  const fetchProductNames = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${urlApiProd}/nombreproductos_ordencompra`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();
        const uniqueProducts = [];
        const seenIds = new Set();
        data.forEach((item) => {
          const id = item.id_producto;
          if (id != null && id !== '' && !seenIds.has(Number(id))) {
            seenIds.add(Number(id));
            uniqueProducts.push(item);
          }
        });
        setProductNames(uniqueProducts);
        return uniqueProducts;
      }
    } catch (error) {
      console.error('Error al obtener nombres de productos:', error);
    }
    return [];
  };

  useEffect(() => {
    fetchProductNames();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (productSearchDropdownRef.current && !productSearchDropdownRef.current.contains(event.target)) {
        setShowProductSearchDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const idProductoPermitidoParaOc = (idProducto) => {
    const id = parseInt(idProducto, 10);
    if (!id) return false;
    const enDisponibles = productosDisponibles.some(
      (p) => parseInt(p.id_producto, 10) === id
    );
    if (!enDisponibles) return false;
    if (!productosRequeridos || productosRequeridos.length === 0) return false;
    return productosRequeridos.some((r) => parseInt(r, 10) === id);
  };

  const normalizarTextoBusqueda = (s) => (s || '').toLowerCase().trim().replace(/\s+/g, ' ');
  const coincideBusquedaProducto = (texto, termNormalizado) => {
    if (!termNormalizado) return true;
    const t = texto;
    if (t.includes(termNormalizado)) return true;
    const tokens = termNormalizado.split(' ').filter(Boolean);
    if (tokens.length <= 1) return false;
    return tokens.every((tok) => t.includes(tok));
  };
  const nombreProductosFiltrados = productNames.filter((p) => {
    if (!idProductoPermitidoParaOc(p.id_producto)) return false;
    const term = normalizarTextoBusqueda(productSearchTerm);
    if (!term) return true;
    const nombre = normalizarTextoBusqueda(p.nombre_producto || '');
    const cal = normalizarTextoBusqueda(p.calidad || '');
    return coincideBusquedaProducto(nombre, term) || coincideBusquedaProducto(cal, term);
  });

  useEffect(() => {
    if (!editMode || !productoSeleccionado) return;
    const m = productNames.find(
      (n) => parseInt(n.id_producto, 10) === parseInt(productoSeleccionado, 10)
    );
    if (m) {
      setProductSearchTerm(m.nombre_producto);
    }
  }, [editMode, productoSeleccionado, productNames]);

  useEffect(() => {
    if (ordenesCompra && ordenesCompra.length > 0) {
      const valoresCorrelativos = ordenesCompra.map(oc => parseInt(oc.correlativo || 0));
      const maxCorrelativo = Math.max(...valoresCorrelativos);
      setCorrelativo(maxCorrelativo + 1);
    } else {
      setCorrelativo(1);
    }
  }, [ordenesCompra]);

  useEffect(() => {
    if (proveedor && correlativo && emision) {
      const provSeleccionado = proveedores.find(p => p.id_proveedor === parseInt(proveedor));
      if (provSeleccionado && provSeleccionado.siglas) {
        const siglas = provSeleccionado.siglas;
        const year = emision.substring(2, 4);
        const corr = correlativo.toString().padStart(2, '0');
        setIdOc(`${siglas} ${corr}-${year}`);
      }
    }
  }, [proveedor, correlativo, emision, proveedores]);

  useEffect(() => {
    if (productos) {
      setProductosDisponibles(productos);
    }
  }, [productos]);

  useEffect(() => {
    // recalcularProductosDisponibles();
    // setProductoSeleccionado(null);
  }, [productosSeleccionados, Productos]);

  useEffect(() => {
    const totalUSD = Productos.reduce((acc, producto) => acc + parseFloat(producto.usd_total || 0), 0);
    setValorOrdenCompra(totalUSD.toFixed(3));
  }, [Productos]);

  useEffect(() => {
    if (!editMode) {
      setCalidadSeleccionada('');
      setM3('');
      setUsdM3('');
    }
  }, [productoSeleccionado, editMode]);

  const cargarDatosOrdenCompra = (idOrdenCompra) => {
    recalcularProductosDisponibles();
    if (idOrdenCompra) {
      const ordenCompra = ordenesCompra.find(oc => oc.id_ordencompra === parseInt(idOrdenCompra));
      const proforma = proformas.find(p => p.id_proforma === ordenCompra.proforma)
      if (ordenCompra) {
        setProforma(ordenCompra.proforma)
        setProveedor(ordenCompra.proveedor);
        setAlmacen(ordenCompra.almacen);
        setIncoTerm(ordenCompra.incoterm);
        setPuerto(ordenCompra.puerto);
        setProductos(ordenCompra.productos.map((prod, index) => ({
          id_producto: prod,
          real_size: ordenCompra.real_size[index],
          m3: ordenCompra.m3[index],
          usd_m3: ordenCompra.usd_m3[index],
          usd_total: ordenCompra.usd_total[index],
          calidad: ordenCompra.calidades[index]
        })));
        setDescripcionProducto(ordenCompra.descripcion_producto);
        setCondicionPago(ordenCompra.condicion_pago);
        setRequisitosCalidad(ordenCompra.requisitos_calidad);
        setRequisitosEtiquetado(ordenCompra.requisitos_etiquetado);
        SetDocumentosRequeridos(ordenCompra.documentos);
        setInformacionAdicional(ordenCompra.informacion_adicional);
        setObservaciones(ordenCompra.observaciones);
        setRemitente(ordenCompra.remitente);
        setAprobador(ordenCompra.aprobador);
        setMoneda(ordenCompra.moneda);
        setAllowance(ordenCompra.allowance);
        setEmpresaEmisor(ordenCompra.empresa_emisor);
        if (proforma) {
          setFechaEmbarqueProforma(proforma.fecha_embarque);
        }
      }
    }
  };

  const getCurrencySymbol = (moneda) => {
    switch (moneda) {
      case 0: return 'USD';
      case 1: return 'EUR';
      case 2: return 'CLP';
      case 3: return 'BRL';
      case 4: return 'PYG';
      default: return 'USD';
    }
  };

  useEffect(() => {
    if (fechaEmbarqueProforma && entrega) {
      const fechaEmbarque = new Date(fechaEmbarqueProforma);
      const fechaEntrega = new Date(entrega);

      if (fechaEntrega >= fechaEmbarque) {
        alert("La fecha de embarque debe ser anterior a la fecha de la proforma.");
        setEntrega('')
        return;
      }
    }
  }, [entrega]);

  const handleSubmit = (event) => {
    event.preventDefault();

    console.log(entrega)
    console.log(fechaEmbarqueProforma)

    if (fechaEmbarqueProforma && entrega) {
      const fechaEmbarque = new Date(fechaEmbarqueProforma);
      const fechaEntrega = new Date(entrega);

      if (fechaEntrega >= fechaEmbarque) {
        alert("La fecha de embarque debe ser anterior a la fecha de la proforma.");
        return;
      }
    }

    setBotonDeshabilitado(true);

    const arrayProductos = [];
    const arrayRealSize = [];
    const arrayM3 = [];
    const arrayUSDM3 = [];
    const arrayUSDTotal = [];
    const arrayCalidad = [];

    Productos.forEach(producto => {
      arrayProductos.push(producto.id_producto)
      arrayRealSize.push(producto.real_size)
      arrayM3.push(producto.m3)
      arrayUSDM3.push(producto.usd_m3)
      arrayUSDTotal.push(producto.usd_total)
      arrayCalidad.push(parseInt(producto.calidad));
    })

    const arrayDocumentos = [];

    documentosRequeridos.forEach(doc => {
      arrayDocumentos.push(doc);
    });

    if (proforma === '') {
      return alert("Ingresa la proforma asociada o si es una PI por crear")
    }

    if (!parseInt(hc, 10) || parseInt(hc, 10) <= 0) {
      return alert('Ingrese el HC (cantidad de contenedores High Cube).');
    }

    const nuevo = {
      proveedor,
      proforma,
      hc: parseInt(hc, 10),
      almacen,
      emision,
      entrega,
      incoterm,
      puerto,
      productos: arrayProductos,
      real_size: arrayRealSize,
      m3: arrayM3,
      usd_m3: arrayUSDM3,
      usd_total: arrayUSDTotal,
      documentos: arrayDocumentos,
      valor_ordencompra,
      condicion_pago,
      requisitos_calidad,
      informacion_adicional,
      requisitos_etiquetado,
      estado,
      remitente,
      aprobador,
      observaciones,
      descripcion_producto,
      calidades: arrayCalidad,
      origen,
      allowance,
      moneda,
      correlativo,
      id_oc,
      empresa_emisor: empresaEmisor
    };

    const token = localStorage.getItem('token');

    fetch(`${urlApiProd}/agregarordencompra`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(nuevo),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error al agregar datos');
        }
        return response.json();
      })
      .then(data => {
        console.log('Datos agregados:', data);
        notificar.exito('Orden de compra agregada exitosamente');
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        notificar.error('Error al agregar orden de compra');
      })
      .finally(() => {
        setBotonDeshabilitado(false);
      });
  };

  const seleccionProveedor = (prov) => {
    if (prov !== 0 && prov !== '0' && prov !== '') {
      const provSeleccionado = proveedores.find(pro => pro.id_proveedor === parseInt(prov));
      if (provSeleccionado) {
        seleccionIT(provSeleccionado.incoterm);
        setPuerto(provSeleccionado.puerto);
        setAlmacen(provSeleccionado.almacen);
        setCondicionPago(provSeleccionado.condicion_pago);
        setRequisitosCalidad(provSeleccionado.requisitos_calidad);
        setRequisitosEtiquetado(provSeleccionado.requisitos_etiquetado);
        setInformacionAdicional(provSeleccionado.informacion_adicional);
        setProveedor(provSeleccionado.id_proveedor);
        setProductosRequeridos(provSeleccionado.productos || []);
      } else {
        setIncoTerm(0);
        setPuerto(0);
        setAlmacen(0);
        setCondicionPago('');
        setRequisitosCalidad('');
        setRequisitosEtiquetado('');
        setInformacionAdicional('');
        setProveedor(0);
        setProductosRequeridos([]);
      }
    }
  }


  const seleccionProforma = (proformaId) => {
    if (proformaId !== 0 && proformaId !== '0' && proformaId !== '') {
      const proformaSeleccionada = proformas.find(ov => ov.id_proforma === parseInt(proformaId));
      if (proformaSeleccionada) {
        const cliente = clientes.find(cli => cli.id_cliente === parseInt(proformaSeleccionada.cliente));
        if (cliente) {
          SetDocumentosRequeridos(cliente.documentos);
          // Si se cambia de proforma (respecto al estado actual), resetear edición actual.
          if (parseInt(proformaSeleccionada.id_proforma, 10) !== parseInt(proforma || 0, 10)) {
            setProductoSeleccionado(null);
            setProductSearchTerm('');
            setEditMode(false);
            setProductoEnEdicion(null);
          }

          // Cargar automáticamente líneas de producto desde la proforma seleccionada.
          const productosDesdeProforma = (proformaSeleccionada.productos || []).map((prod, index) => {
            const m3Linea = parseFloat(proformaSeleccionada.m3?.[index] || 0);
            const usdM3Linea = parseFloat(proformaSeleccionada.usd_m3?.[index] || 0);
            const totalLinea = parseFloat(proformaSeleccionada.usd_total?.[index] || (m3Linea * usdM3Linea));
            return {
              id_producto: prod,
              real_size: proformaSeleccionada.real_size?.[index] || '',
              m3: m3Linea,
              usd_m3: usdM3Linea,
              usd_total: totalLinea,
              calidad: proformaSeleccionada.calidad?.[index] || ''
            };
          });
          setProductos(productosDesdeProforma);

          setProforma(proformaSeleccionada.id_proforma);
          setProductosRequeridos(proformaSeleccionada.productos || []);
          setFechaEmbarqueProforma(proformaSeleccionada.fecha_embarque);
        }
      }
    } else {
      // Si se selecciona "Proforma por crear", mostrar todos los proveedores con productos
      setProforma(proformaId);
      setProductosRequeridos([]); // Reiniciar productos requeridos
      setIncoTerm(0);
      setPuerto(0);
      SetDocumentosRequeridos([]);
      setProveedor(0);
      setProductos([]);
      setFechaEmbarqueProforma('');
    }
  };

  useEffect(() => {
    if (ordenCompraBase) {
      const ordenCompra = ordenesCompra.find(oc => oc.id_ordencompra === parseInt(ordenCompraBase));
      if (ordenCompra) {
        const proveedorSeleccionado = proveedores.find(prov => prov.id_proveedor === ordenCompra.proveedor);
        if (proveedorSeleccionado) {
          setProveedoresFiltrados([proveedorSeleccionado]);
        }
      }
    } else {
      // Lógica para cuando no se ha seleccionado una orden de compra base
      if (proforma === '0') {
        setProveedoresFiltrados(proveedores);
      } else {
        const proveedoresFiltrados = proveedores.filter(proveedor => {
          let productosProveedor = proveedor.productos;
          if (productosProveedor) {
            let proveedorConProducto = productosProveedor?.filter(prodpro =>
              productosRequeridos?.includes(prodpro)
            );
            return proveedorConProducto.length > 0;
          }
          return false;
        });
        setProveedoresFiltrados(proveedoresFiltrados);
      }
    }
  }, [ordenCompraBase, proforma, productosRequeridos, proveedores, ordenesCompra]);


  const columnsProductos = [
    {
      name: 'Producto',
      selector: row => {
        if (!row.id_producto) return '';
        const productoEncontrado =
          productos.find((prod) => parseInt(prod.id_producto, 10) === parseInt(row.id_producto, 10)) ||
          productosDisponibles.find((prod) => parseInt(prod.id_producto, 10) === parseInt(row.id_producto, 10));
        if (productoEncontrado) {
          const categoriaEncontrada = categorias.find(
            (categoria) => parseInt(categoria.id_categoria, 10) === parseInt(productoEncontrado.categoria, 10)
          );
          const especieEncontrada = especies.find(
            (especie) => parseInt(especie.id_especie, 10) === parseInt(productoEncontrado.especie, 10)
          );
          const medidaEncontrada = medidas.find(
            (medida) => parseInt(medida.id_medida, 10) === parseInt(productoEncontrado.medida, 10)
          );
          if (categoriaEncontrada && especieEncontrada && medidaEncontrada) {
            const espMostrar = productoEncontrado.espesor;
            return (
              categoriaEncontrada.nombre +
              ' de ' +
              especieEncontrada.nombre +
              ' ' +
              espMostrar +
              ' X ' +
              medidaEncontrada.ancho +
              ' X ' +
              medidaEncontrada.largo
            );
          }
        }
        const nomOc = productNames.find(
          (n) => parseInt(n.id_producto, 10) === parseInt(row.id_producto, 10)
        );
        return nomOc?.nombre_producto || '';
      },
    },
    {
      name: 'Calidad',
      selector: row => {
        if (row.calidad) {
          const calidadEncontrada = calidades.find(cal => parseInt(cal.id_calidad) === parseInt(row.calidad));
          if (calidadEncontrada) {
            return calidadEncontrada.calidad;
          }
        }
      },
      width: '15%',
    },
    {
      name: 'Real Size',
      selector: row => row.real_size,
      width: '15%',
    },
    {
      name: 'm3',
      selector: row => row.m3,
      width: '15%',
    },
    {
      name: `${getCurrencySymbol(moneda)}/m3`,
      selector: row => row.usd_m3,
      width: '15%',
    },
    {
      name: `Total ${getCurrencySymbol(moneda)}`,
      selector: row => row.usd_total,
      width: '15%',
    },
    {
      name: 'Editar',
      cell: row => (
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={() => handleEditProducto(row)}
        >
          Editar
        </button>
      ),
      ignoreRowClick: true,
      width: '100px',
    },
    {
      name: 'Eliminar',
      cell: row => (
        <div className="delete-button-container">
          <button
            type="button"
            className="btn btn-outline-danger delete-button"
            onClick={() => {
              if (window.confirm('¿Estás seguro?')) {
                handleDeleteProducto(row.id_producto, row.calidad);
              }
            }}
          >
            X
          </button>
        </div>
      ),
      ignoreRowClick: true,
      width: '100px',
    },
  ];

  const columnsDocumentos = [
    {
      name: 'Documentos',
      selector: row => {
        if (row) {
          const docEncontrado = documentos.find(d => parseInt(d.id_documento) === parseInt(row));
          if (docEncontrado) {
            return docEncontrado.nombre
          }
        }
      },
    },
    {
      name: 'Eliminar',
      cell: row => (
        <div className="delete-button-container">
          <button
            type="button"
            className="btn btn-outline-danger delete-button"
            onClick={() => {
              if (window.confirm('¿Estás seguro?')) {
                handleDeleteDocumento(row)
              }
            }}
          >
            X
          </button>
        </div>
      ),
      ignoreRowClick: true,
      width: '100px',
    },
  ];

  const handleDeleteProducto = (id_producto, calidad) => {
    const updatedProductos = Productos.filter((producto) =>
      producto.id_producto !== id_producto || producto.calidad !== calidad
    );

    if (updatedProductos.length !== Productos.length) {
      setProductos(updatedProductos);
      if (updatedProductos.length === 0) {
        setDescripcionProducto('');
      }
    } else {
      alert('El producto con la ID y calidad especificadas no se encontró.');
    }
  };

  const handleEditProducto = (producto) => {
    setProductoSeleccionado(producto.id_producto);
    setCalidadSeleccionada(producto.calidad);
    setM3(producto.m3);
    setUsdM3(producto.usd_m3);
    setEditMode(true);
    setProductoEnEdicion(producto);
    const np = productNames.find(
      (n) => parseInt(n.id_producto, 10) === parseInt(producto.id_producto, 10)
    );
    if (np) setProductSearchTerm(np.nombre_producto);
  };

  const handleAgregarProducto = () => {
    if (productoSeleccionado) {
      const producto = productosDisponibles.find(prod => parseInt(prod.id_producto) === parseInt(productoSeleccionado));

      if (producto) {
        if (!m3 || !usdM3) {
          alert('Por favor ingrese todos los detalles requeridos (m3, Precio).');
          return;
        }

        if (editMode && productoEnEdicion) {
          // Logica de EDICION
          const updatedProductos = Productos.map(prod => {
            if (prod.id_producto === productoEnEdicion.id_producto) {
              return {
                ...prod,
                m3: parseFloat(parseFloat(m3).toFixed(3)),
                usd_m3: parseFloat(parseFloat(usdM3).toFixed(3)),
                usd_total: parseFloat((parseFloat(m3) * parseFloat(usdM3)).toFixed(3)),
              };
            }
            return prod;
          });
          setProductos(updatedProductos);
          setEditMode(false);
          setProductoEnEdicion(null);

          setM3('');
          setUsdM3('');
          setProductoSeleccionado(null);
          setCalidadSeleccionada('');
          setProductSearchTerm('');
          alert("Producto actualizado exitosamente.");
        } else {
          // Logica de AGREGAR (existente)
          const categoriaSeleccionada = categorias.find(categoria => parseInt(categoria.id_categoria) === parseInt(producto.categoria));
          const especieSeleccionada = especies.find(especie => parseInt(especie.id_especie) === parseInt(producto.especie));
          const medidaEncontrada = medidas.find(m => m.id_medida === producto.medida);

          if (medidaEncontrada && categoriaSeleccionada && especieSeleccionada) {
            const indiceEspesor = medidaEncontrada.espesor.findIndex(e => e === producto.espesor);

            if (indiceEspesor !== -1) {
              const espesorrCorrespondiente = medidaEncontrada.espesorr[indiceEspesor];

              const nuevo = {
                id_producto: parseInt(producto.id_producto),
                real_size: `${espesorrCorrespondiente} x ${medidaEncontrada.anchor} x ${medidaEncontrada.largor}`,
                m3: parseFloat(parseFloat(m3).toFixed(3)),
                usd_m3: parseFloat(parseFloat(usdM3).toFixed(3)),
                usd_total: parseFloat((parseFloat(m3) * parseFloat(usdM3)).toFixed(3)),
                calidad: parseInt(producto.id_calidad),
              };

              setProductos([...Productos, nuevo]);
              setDescripcionProducto(`${categoriaSeleccionada.nombre_portugues} ${especieSeleccionada.nombre_portugues}`);
              setM3('');
              setUsdM3('');
              alert("Producto Agregado");
            } else {
              alert("El espesor seleccionado no coincide con ningún espesorr disponible.");
            }
          } else {
            alert("Medida no encontrada.");
          }
        }
      } else {
        alert("Debe seleccionar un producto.");
      }
    } else {
      alert("Producto no seleccionado.");
    }
  };

  const handleDeleteDocumento = (id) => {
    const updatedDocumentos = documentosRequeridos.filter((doc) => doc !== id);
    SetDocumentosRequeridos(updatedDocumentos);
  };

  const handleAgregarDocumento = () => {
    if (nuevoDocumento) {
      const documentoSeleccionado = documentos.find(d => parseInt(d.id_documento) === parseInt(nuevoDocumento));
      if (documentoSeleccionado) {
        const nuevo = documentoSeleccionado.id_documento
        SetDocumentosRequeridos([...documentosRequeridos, nuevo]);
        setNuevoDocumento(null);
      } else {
        alert("No se puede agregar");
      }
    }
  }

  const seleccionIT = (incoterm) => {
    if (incoterm !== 0) {
      const itSeleccionado = incoterms.find(i => i.id_incoterm === parseInt(incoterm))
      if (itSeleccionado) {
        if (itSeleccionado.indicador === 1) {
          setIncoTerm(itSeleccionado.id_incoterm)
          setIndicadorIT(1);
        } else if (itSeleccionado.indicador === 2) {
          setIncoTerm(itSeleccionado.id_incoterm)
          setIndicadorIT(2);
        } else if (itSeleccionado.indicador === 3) {
          setIncoTerm(itSeleccionado.id_incoterm)
          setIndicadorIT(3);
        } else {
          console.log("Error con el indicador")
        }
      } else {
        console.log("No se encontro el incoterm")
      }
    }
  }

  const obtenerCalidadesDisponibles = (productoId) => {
    // Verificación para evitar errores si no hay productoId o productosp
    if (!productoId || !Productos || Productos.length === 0) {
      console.log(productoId)
      console.log(Productos)
      console.log(Productos.length)
      if (productoId) {
        const calidadesProducto = productosDisponibles.find(prod => prod.id_producto === productoId)
        if (calidadesProducto && calidadesProducto.calidades) {
          return calidades.filter(cal => calidadesProducto.calidades.includes(cal.id_calidad));
        }
      }
      return calidades; // Devolver todas las calidades si no hay restricciones
    }

    console.log(Productos);
    console.log(productoId);

    // Obtener las calidades asociadas al producto seleccionado
    const productoActual = productosDisponibles.find(p => p.id_producto === parseInt(productoId));
    if (productoActual && productoActual.calidades) {
      // Filtrar del array global de calidades aquellas cuyo ID esté en la lista de calidades del producto
      return calidades.filter(cal => productoActual.calidades.includes(cal.id_calidad));
    }

    return calidades;
    // return calidades.filter(cal => !calidadesUsadas.includes(cal.id_calidad));
  };


  const recalcularProductosDisponibles = () => {
    const productosFiltrados = productos.filter(producto => {
      const calidadesDisponibles = obtenerCalidadesDisponibles(producto.id_producto);
      console.log(calidadesDisponibles)
      return calidadesDisponibles.length > 0;
    });
    console.log(productosFiltrados)
    setProductosDisponibles(productosFiltrados);
  };

  return (
    <div className="modal-overlay">
      <div className="modal1">
        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="card-header">
              <div className="card-title" style={{ textAlign: 'center' }}>Agregar Orden de compra</div>
            </div>
            <div className="card-body">
              <div className="input-group mb-3">
                <span className="input-group-text">Proveedor</span>
                <select
                  className="form-select"
                  value={proveedor}
                  onChange={(e) => seleccionProveedor(e.target.value)}
                >
                  <option value="">Seleccione un proveedor</option>
                  {proveedores.map((pro) => (
                    <option key={pro.id_proveedor} value={pro.id_proveedor}>
                      {pro.nombre}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group mb-3">
                <span className='input-group-text'>Filtro Producto</span>
                <select
                  className="form-select"
                  value={descripcionFiltro}
                  onChange={(e) => setDescripcionFiltro(e.target.value)}
                >
                  <option value="">Todos los productos</option>
                  {[...new Set(ordenesCompra
                    .filter(oc => !proveedor || parseInt(oc.proveedor) === parseInt(proveedor))
                    .map(oc => oc.descripcion_producto))]
                    .sort()
                    .map(desc => (
                      <option key={desc} value={desc}>{desc}</option>
                    ))
                  }
                </select>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Basada en Orden de Compra</span>
                <select
                  className="form-select"
                  value={ordenCompraBase}
                  onChange={(e) => {
                    setOrdenCompraBase(e.target.value);
                    cargarDatosOrdenCompra(e.target.value);
                  }}
                >
                  <option value="">Seleccione una Orden de Compra</option>
                  {ordenesCompra.slice()
                    .filter(oc => (!proveedor || parseInt(oc.proveedor) === parseInt(proveedor)) && (!descripcionFiltro || oc.descripcion_producto === descripcionFiltro))
                    .sort((a, b) => b.correlativo - a.correlativo)
                    .map((oc) => (
                      <option key={oc.id_ordencompra} value={oc.id_ordencompra}>
                        {oc.correlativo + ' - ' + proveedores.find(p => p.id_proveedor === oc.proveedor)?.nombre + ' - ' + oc.descripcion_producto}
                      </option>
                    ))}
                </select>
              </div>
              <div className="input-group mb-3">
                <span className='input-group-text'>Moneda</span>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="usd"
                    value={0}
                    checked={moneda === 0}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="usd">USD</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="eur"
                    value={1}
                    checked={moneda === 1}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="eur">EUR</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="clp"
                    value={2}
                    checked={moneda === 2}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="clp">CLP</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="brl"
                    value={3}
                    checked={moneda === 3}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="brl">BRL</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="pyg"
                    value={4}
                    checked={moneda === 4}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="pyg">PYG</label>
                </div>
              </div>
              <div className="input-group mb-3">
                <span className='input-group-text'>Empresa Emisor</span>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="empresaEmisor"
                    id="ptc"
                    value={0}
                    checked={empresaEmisor === 0}
                    onChange={(e) => setEmpresaEmisor(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="ptc">PTC</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="empresaEmisor"
                    id="ptb"
                    value={1}
                    checked={empresaEmisor === 1}
                    onChange={(e) => setEmpresaEmisor(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="ptb">PTB</label>
                </div>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Proforma</span>
                <select
                  className="form-select"
                  value={proforma}
                  onChange={(e) => seleccionProforma(e.target.value)}
                >
                  <option value="">Seleccione una Proforma</option>
                  <option value={0}>Proforma por crear</option>
                  {proformas.map((Pi) => {
                    const clienteExistente = clientes.find(cli => cli.id_cliente === Pi.cliente);
                    if (clienteExistente) {
                      return (
                        <option key={Pi.id_proforma} value={Pi.id_proforma}>
                          {Pi.id_pi ? Pi.id_pi : (
                            `${clienteExistente?.siglas} ${parseInt(Pi.correlativo) < 10 ? '0' + Pi.correlativo : Pi.correlativo}-${isNaN(new Date(Pi.fecha_embarque).getUTCFullYear())
                              ? '00'
                              : new Date(Pi.fecha_embarque).getUTCFullYear().toString().substr(-2)}`
                          )} - {clienteExistente?.nombre}
                        </option>
                      );
                    }
                    return null;
                  })}
                </select>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">HC</span>
                <input
                  type="number"
                  min="1"
                  step="1"
                  className="form-control"
                  placeholder="Ingrese cantidad de contenedores High Cube"
                  value={hc}
                  onChange={(e) => setHc(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Fecha de Emisión</span>
                <DateInput
                  value={emision}
                  onChange={(e) => setEmision(e.target.value)}
                />
              </div>

              {/* Muestra la fecha de embarque de la proforma seleccionada */}
              {fechaEmbarqueProforma && (
                <div className="mb-3">
                  <strong>Fecha de embarque de la Proforma seleccionada: {new Date(fechaEmbarqueProforma).toLocaleDateString('es-ES')}</strong>
                </div>
              )}
              <div className="input-group mb-3">
                <span className="input-group-text">Fecha Embarque</span>
                <DateInput
                  value={entrega}
                  onChange={(e) => setEntrega(e.target.value)}
                />
              </div>
              <div className='input-group mb-3'>
                <span className='input-group-text'>Origen</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Origen"
                  value={origen}
                  onChange={(e) => setOrigen(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">IncoTerm</span>
                <select
                  className="form-select"
                  value={incoterm}
                  onChange={(e) => seleccionIT(e.target.value)}
                >
                  <option value="">Seleccione un IncoTerm</option>
                  {incoterms.map((it) => (
                    <option key={it.id_incoterm} value={it.id_incoterm}>
                      {it.nombre}
                    </option>
                  ))}
                </select>
              </div>
              {indicadorIT === 2 &&
                <div className="input-group mb-3">
                  <span className="input-group-text">Almacén</span>
                  <select
                    className="form-select"
                    value={almacen}
                    onChange={(e) => setAlmacen(e.target.value)}
                  >
                    <option value="">Seleccione un almacén</option>
                    {almacenes.map((alm) => (
                      <option key={alm.id_almacen} value={alm.id_almacen}>
                        {alm.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              }
              {indicadorIT === 1 &&
                <div className="input-group mb-3">
                  <span className="input-group-text">Puerto</span>
                  <select
                    className="form-select"
                    value={puerto}
                    onChange={(e) => setPuerto(e.target.value)}
                  >
                    <option value="">Seleccione un Puerto de Destino</option>
                    {puertos.map((puerto) => (
                      <option key={puerto.id_puerto} value={puerto.id_puerto}>
                        {puerto.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              }
              <div className="input-group mb-3">
                <span className="input-group-text">Descripción Producto</span>
                <input
                  type="text"
                  className="form-control"
                  value={descripcion_producto}
                  readOnly
                />
              </div>
              <div className="mb-3">
                <h5 style={{ textAlign: 'center' }}>Productos</h5>
                <div className="mb-3 position-relative" ref={productSearchDropdownRef} style={{ zIndex: 20 }}>
                  <label className="form-label fw-bold">Selecciona un producto:</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-search text-primary"></i></span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Escribe el nombre de un producto..."
                      value={productSearchTerm}
                      onChange={(e) => {
                        const v = e.target.value;
                        setProductSearchTerm(v);
                        setShowProductSearchDropdown(true);
                      }}
                      onFocus={() => setShowProductSearchDropdown(true)}
                      style={{ borderLeft: 'none' }}
                      disabled={editMode}
                    />
                    {productoSeleccionado && !editMode && (
                      <button
                        type="button"
                        className="btn btn-outline-danger"
                        onClick={() => {
                          setProductoSeleccionado(null);
                          setProductSearchTerm('');
                        }}
                      >
                        <i className="bi bi-x-circle"></i> Limpiar
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-outline-success"
                      onClick={() => setShowAgregarProducto(true)}
                      disabled={editMode}
                    >
                      Crear Producto
                    </button>
                  </div>
                  {showProductSearchDropdown && !editMode && (
                    <div
                      className="list-group position-absolute w-100 shadow-lg"
                      style={{ zIndex: 1050, maxHeight: '250px', overflowY: 'auto', top: '100%' }}
                    >
                      {nombreProductosFiltrados.map((p, idx) => (
                        <button
                          key={`${p.id_producto}-${idx}`}
                          type="button"
                          className="list-group-item list-group-item-action text-start"
                          onClick={() => {
                            setProductoSeleccionado(parseInt(p.id_producto, 10));
                            setProductSearchTerm(p.nombre_producto);
                            setShowProductSearchDropdown(false);
                          }}
                        >
                          <span className="fw-medium">{p.nombre_producto}</span>
                        </button>
                      ))}
                      {nombreProductosFiltrados.length === 0 && (
                        <div className="list-group-item disabled text-muted fst-italic">
                          {productSearchTerm.trim()
                            ? 'No se encontraron productos coincidentes'
                            : 'No hay productos disponibles para la proforma/proveedor seleccionados'}
                        </div>
                      )}
                    </div>
                  )}
                  {productoSeleccionado && !editMode && (
                    <div className="mt-2 p-2 bg-light rounded border-start border-success border-4 d-flex align-items-center">
                      <i className="bi bi-check-circle-fill text-success me-2" style={{ fontSize: '1.2rem' }}></i>
                      <div>
                        <small className="text-muted d-block">Producto seleccionado:</small>
                        <span className="fw-bold text-success">{productSearchTerm}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="input-group mb-3">
                  <span className="input-group-text">m3</span>
                  <input
                    type="number"
                    id="m3"
                    className="form-control"
                    value={m3}
                    onChange={(e) => setM3(e.target.value)}
                  />
                  <span className="input-group-text">{getCurrencySymbol(moneda)}/m3</span>
                  <input
                    type="number"
                    id="usd_m3"
                    className="form-control"
                    value={usdM3}
                    onChange={(e) => setUsdM3(e.target.value)}
                  />
                </div>
                <button
                  type="button"
                  onClick={handleAgregarProducto}
                  className="btn btn-outline-primary"
                  disabled={!productoSeleccionado || !m3 || !usdM3}
                >
                  {editMode ? 'Editar Producto' : 'Agregar Producto'}
                </button>
                <DataTable
                  columns={columnsProductos}
                  data={Productos}
                  highlightOnHover
                  dense
                  pagination={true}
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Valor Orden de Compra (${getCurrencySymbol(moneda)})</span>
                <input
                  type="text"
                  className="form-control"
                  value={valor_ordencompra}
                  readOnly
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Allowance</span>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Ingrese allowance"
                  value={allowance}
                  onChange={(e) => setAllowance(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Condición de Pago</span>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Ingrese condiciones de pago"
                  value={condicion_pago}
                  onChange={(e) => setCondicionPago(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Requisitos Calidad</span>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Requisitos de calidad"
                  value={requisitos_calidad}
                  onChange={(e) => setRequisitosCalidad(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Información Adicional</span>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Requisitos de etiquetado"
                  value={informacion_adicional}
                  onChange={(e) => setInformacionAdicional(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Requisitos Etiquetado</span>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Requisitos de etiquetado"
                  value={requisitos_etiquetado}
                  onChange={(e) => setRequisitosEtiquetado(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <h5 style={{ textAlign: 'center' }}>Documentos Requeridos</h5>
                <div className="input-group mb-3">
                  <span className="input-group-text">Documento</span>
                  <select
                    value={nuevoDocumento}
                    onChange={e => setNuevoDocumento(e.target.value)}
                    className="form-control"
                  >
                    <option value="">Seleccionar Documento</option>
                    {documentos.map((td) => {
                      const tdExistente = documentosRequeridos.some(dr => parseInt(dr) === parseInt(td.id_documento));
                      if (!tdExistente) {
                        return (
                          <option key={td.id_documento} value={td.id_documento}>
                            {td.nombre}
                          </option>
                        );
                      }
                      return null;
                    })}
                  </select>
                  <button type="button" onClick={handleAgregarDocumento} className="btn btn-outline-primary" disabled={!nuevoDocumento}>
                    Agregar Documento
                  </button>
                </div>
                <DataTable
                  columns={columnsDocumentos}
                  data={documentosRequeridos}
                  highlightOnHover
                  dense
                  pagination={true}
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Remitente</span>
                <select
                  className="form-select"
                  value={remitente}
                  onChange={(e) => setRemitente(e.target.value)}
                >
                  <option value="">Seleccione un Remitente</option>
                  {usuarios.map((user) => (
                    <option key={user.id_usuario} value={user.id_usuario}>
                      {user.nombre}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Aprobador</span>
                <select
                  className="form-select"
                  value={aprobador}
                  onChange={(e) => setAprobador(e.target.value)}
                >
                  <option value="">Seleccione un Aprobador</option>
                  {usuarios
                    .filter(user => user.rol === 1)
                    .map(user => (
                      <option key={user.id_usuario} value={user.id_usuario}>
                        {user.nombre}
                      </option>
                    ))}
                </select>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Observaciones</span>
                <textarea
                  type="text"
                  className="form-control"
                  value={observaciones}
                  onChange={(e) => setObservaciones(e.target.value)}
                />
              </div>
            </div>
            <div className="card-footer" style={{ textAlign: 'center' }}>
              <button
                type="submit"
                className="btn btn-outline-success mb-3 mt-3"
                disabled={botonDeshabilitado}
              >
                Guardar
              </button>
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => {
                  if (window.confirm('¿Estás seguro de cancelar? Se perderán los datos no guardados.')) {
                    cerrar();
                  }
                }}
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
      <Modal show={showAgregarProducto} onHide={() => setShowAgregarProducto(false)} size="lg" style={{ zIndex: 11000 }}>
        <Modal.Header closeButton>
          <Modal.Title>Crear Producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AgregarProducto
            cerrar={async (nuevo) => {
              setShowAgregarProducto(false);
              if (nuevo && nuevo.id_producto) {
                const productoConTiposCorrectos = {
                  ...nuevo,
                  id_producto: parseInt(nuevo.id_producto),
                  categoria: parseInt(nuevo.categoria),
                  especie: parseInt(nuevo.especie),
                  medida: parseInt(nuevo.medida),
                };
                setProductosDisponibles(prev => [...prev, productoConTiposCorrectos]);
                setProductoSeleccionado(parseInt(productoConTiposCorrectos.id_producto));
                // Agregar a productosRequeridos para permitir selección si es necesario
                setProductosRequeridos(prev => [...prev, parseInt(productoConTiposCorrectos.id_producto)]);
                const lista = await fetchProductNames();
                const byId = lista.find(
                  (item) => parseInt(item.id_producto, 10) === parseInt(productoConTiposCorrectos.id_producto, 10)
                );
                setProductSearchTerm(byId?.nombre_producto || '');
              }
            }}
            opciones={{ categorias, especies, calidades, medidas }}
            medidas={medidas}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AgregarOrdenCompra;
